import { Component, OnInit, ViewChild } from '@angular/core';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { PaymentService } from '../services/payment/payment.service';
import { validityExntension } from '../models/validityextension';
import { Account } from '../models/account';

declare var $: any;

@Component({
  selector: 'app-package-validity-extension',
  templateUrl: './package-validity-extension.component.html',
  styleUrls: ['./package-validity-extension.component.css']
})
export class PackageValidityExtensionComponent implements OnInit {

  @ViewChild('extensionModal', { static: true }) extensionModal;
  @ViewChild('extensionHistoryModal', { static: true }) extensionHistoryModal;

  customDateFormat="";
  subscriptionExtensionHistory: validityExntension[] = [];
  extensionInfo: validityExntension = new validityExntension(); packagesBackup: any[] = [];
  accounts: Account[] = []; screeningCenters: any[] = [];
  accountId = null; orgId = null; packagesSubscribed: any = [];
  totalRecords: number = 0;
  currentStatus: string = 'All';
  constructor(public foruscareService: ForuscareService, public accountService: AccountService, public paymentService: PaymentService) { }

  ngOnInit() {
    this.customDateFormat = this.foruscareService.getDateFormat();
    for (var i = 1; i <= 5; i++) {
      $('#' + i).css("border-bottom", "none");
    }
    $('#1').css("border-bottom", "2px solid rgb(53,191,224");
    this.getAccounts();
  }

  getAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status.toLowerCase() == this.foruscareService.RESULT_SUCCESS.toLowerCase()) {
          if (response.data != null) {
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  closeExtensionHistoryWindow() {
    this.extensionHistoryModal.hide();
  }

  getPackageExtensionHistory(subscriptionId) {
    this.subscriptionExtensionHistory = [];
    if (subscriptionId != null) {
      this.paymentService.getPackageExtensionHistory(subscriptionId)
        .subscribe(response => {
          if (response.errorCode == 200 && response.status.toLowerCase() == this.foruscareService.RESULT_SUCCESS.toLowerCase()) {
            if (response.data != null && response.data.length > 0) {
              this.subscriptionExtensionHistory = response.data;
              this.extensionHistoryModal.show();
            }
            else {
              this.foruscareService.showNotification("no record found", "danger");
            }
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }
  }

  onlyNumberKey(event) {
    // return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    return (event.charCode == 8 || event.charCode == 0) ? null : this.extensionInfo?.validityExt > 0 ?  event.charCode >= 48 && event.charCode <= 57 : event.charCode > 48 && event.charCode <= 57;
  }

  onlyAlphabets(event){
    return (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 65 && event.charCode <= 90) || (this.extensionInfo.requestedBy?.length > 0 && event.charCode === 32 );
  }


  onPasteRequestedBy(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text/plain');
    if (/[^\w\s]/.test(pastedText)) {
      // If pasted text contains special characters, prevent the paste operation
      // console.log("Pasting special characters is not allowed.");
      return;
    }
    // Allow paste operation
    this.extensionInfo.requestedBy += pastedText;
  }

  onPasteDaysNumber(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text/plain');

    // Check if the pasted text contains only numbers or a negative sign
    if (!/^\d+$/.test(pastedText) && !/^-?\d+$/.test(pastedText)) {
      // console.log("Invalid input. Only numbers are allowed.");
      return;
    }
    // Allow paste operation
    this.extensionInfo.validityExt = +(`${this.extensionInfo.validityExt}${pastedText}`);
  }

  updateValidity() {
    this.paymentService.updatePackageValidity(this.extensionInfo)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status.toLowerCase() == this.foruscareService.RESULT_SUCCESS.toLowerCase()) {
          if (response.data != null) {
            this.extensionModal.hide();
            this.getPackagesSubscribed(0, 'All');
            this.foruscareService.showNotification("Package validity extented successfully", "success");
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  filterPackagesByStatus(status, id) {
    this.currentStatus = status;
    this.getPackagesSubscribed(0, this.currentStatus);
    for (var i = 1; i <= 5; i++) {
      $('#' + i).css("border-bottom", "none");
    }
    $('#' + id).css("border-bottom", "2px solid rgb(53,191,224");
    if (status == 'ALL') {
      this.packagesSubscribed = this.packagesBackup.filter(function(t){
        return t.currentStatus!="PACKAGE_SUBSCRIPTION_INITIATED";
      });
    }
    else {
      var filteredData = this.packagesBackup.filter(function (t) {
        return t.currentStatus == status;
      });
      this.packagesSubscribed = filteredData;
    }
  }

  closeWindow() {
    this.extensionModal.hide();
  }

  getScreeningCentersByAccountID() {
    if (this.accountId != null && this.accountId > 0) {
      //this.getPackagesSubscribed(0);
      this.accountService.screeningCentersByAccount(this.accountId)
        .subscribe(response => {
          if (response.errorCode == 200 && response.status.toLowerCase() == this.foruscareService.RESULT_SUCCESS.toLowerCase()) {
            if (response.data != null) {
              this.screeningCenters = response.data;
            }
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }
    else {
      this.packagesSubscribed = [];
    }
  }

  openValidityExtensionWindow(subscriptionInfo) {
    if (subscriptionInfo != null) {
      this.extensionInfo = new validityExntension();
      this.extensionInfo.subId = subscriptionInfo.id;
      this.extensionInfo.pkgId = subscriptionInfo.pkgId;
      this.extensionModal.show();
    }
  }
  onPageChange(event) {
    let offset = event.first;

    this.getPackagesSubscribed(offset, this.currentStatus);
  }
  getPackagesSubscribed(offset, currentStatus) {
    let count = 10;
    this.packagesSubscribed = [];
    this.packagesBackup = [];
    this.paymentService.getPackagesSubscribedByAccountAndOrgPaging(this.accountId, this.orgId, count, offset, currentStatus)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status.toLowerCase() == this.foruscareService.RESULT_SUCCESS.toLowerCase()) {
          if (response.data != null) {
            if (response.data.response.length > 0) {
              this.packagesBackup = response.data.response;
              this.totalRecords = response.data.totalCount;
              response.data.response.forEach(packageinfo => {
                this.packagesSubscribed.push(packageinfo);
              });
             // this.filterPackagesByStatus('ALL', 1);
            }
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }
}
